/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_My_PlanInputs */

const en_cancel_my_plan = /** @type {(inputs: Cancel_My_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel my plan`)
};

const de_cancel_my_plan = /** @type {(inputs: Cancel_My_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abo kuendigen`)
};

const fr_cancel_my_plan = /** @type {(inputs: Cancel_My_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler mon abonnement`)
};

const es_cancel_my_plan = /** @type {(inputs: Cancel_My_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar mi plan`)
};

const it_cancel_my_plan = /** @type {(inputs: Cancel_My_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla il mio piano`)
};

const nl_cancel_my_plan = /** @type {(inputs: Cancel_My_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan annuleren`)
};

const pl_cancel_my_plan = /** @type {(inputs: Cancel_My_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuluj plan`)
};

const fi_cancel_my_plan = /** @type {(inputs: Cancel_My_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruuta tilaukseni`)
};

const da_cancel_my_plan = /** @type {(inputs: Cancel_My_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuller min plan`)
};

const sv_cancel_my_plan = /** @type {(inputs: Cancel_My_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avbryt min plan`)
};

/**
* | output |
* | --- |
* | "Cancel my plan" |
*
* @param {Cancel_My_PlanInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_my_plan = /** @type {((inputs?: Cancel_My_PlanInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_My_PlanInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_my_plan(inputs)
	if (locale === "fr") return fr_cancel_my_plan(inputs)
	if (locale === "es") return es_cancel_my_plan(inputs)
	if (locale === "it") return it_cancel_my_plan(inputs)
	if (locale === "nl") return nl_cancel_my_plan(inputs)
	if (locale === "pl") return pl_cancel_my_plan(inputs)
	if (locale === "fi") return fi_cancel_my_plan(inputs)
	if (locale === "da") return da_cancel_my_plan(inputs)
	if (locale === "sv") return sv_cancel_my_plan(inputs)
	return en_cancel_my_plan(inputs)
});